import { render } from "./TradeQuoteEdit.vue?vue&type=template&id=b465c5e2&scoped=true"
import script from "./TradeQuoteEdit.vue?vue&type=script&lang=js"
export * from "./TradeQuoteEdit.vue?vue&type=script&lang=js"

import "./TradeQuoteEdit.vue?vue&type=style&index=0&id=b465c5e2&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b465c5e2"]])

export default __exports__